"use client";

import { usePathname } from "next/navigation";

import { isLpPath } from "@/lib/region";

// Pathname-driven chrome swap needs to live in a client component since
// the layout above doesn't re-render on navigation.
export function HideOnLp({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  return isLpPath(pathname) ? null : <>{children}</>;
}

export function ShowOnLp({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  return isLpPath(pathname) ? <>{children}</> : null;
}
